import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NpsDialogComponent } from './nps-dialog.component';
import { Overlay } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class NpsDialogService {
  private dialogRef: MatDialogRef<NpsDialogComponent> | null = null;

  constructor(
    private readonly dialog: MatDialog,
    private readonly overlay: Overlay
  ) {}

  open(): MatDialogRef<NpsDialogComponent> {
    this.dialogRef?.close();

    this.dialogRef = this.dialog.open(NpsDialogComponent, {
      position: {
        bottom: '20px',
        right: '20px',
      },
      panelClass: 'nps-dialog-panel',
      hasBackdrop: false,
      // Prevent ESC or backdrop click from closing without an explicit action,
      // so that we only save on button clicks.
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      maxWidth: '600px',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });

    return this.dialogRef;
  }

  close(): void {
    this.dialogRef?.close();
  }

  isOpen(): boolean {
    return this.dialogRef !== null;
  }
}
